export default {
      id: "video-event_parking-heavy-hit-usage",
      viewBox: "0 0 40 43",
      url: __webpack_public_path__ + "img/icons.svg#video-event_parking-heavy-hit",
      toString: function () {
        return this.url;
      }
    }